import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FeatureConfigActions from "../../store/actions/FeatureConfig";
import { isMobile } from "../../utils";
import HomeComponent from "../../components/FeatureConfig/Home/Index";
import ListView from "../../components/FeatureConfig/ConfigList/ListView";
import * as UserActions from "../../store/actions/User";
import ListPagination from "../../components/Common/ListPagination";

const FeatureConfig = (props) => {
  const location = useLocation();
  const searchQueryParams = location.search;
  const params = new URLSearchParams(searchQueryParams);
  const configMetadata = {
    namespace: params.get("namespace"),
    key: params.get("key"),
    entity: params.get("entity"),
    entityId: params.get("entityId"),
  };
  const activeHierarchyFiltersConfig = {
    entity: params.get("entity"),
    entityId: params.get("entityId"),
  };
  const activeCityId = params.get("cityId");

  const { setSideBarCollapsed } = props;
  React.useEffect(() => {
    setSideBarCollapsed(true);
  });

  return (
    <FeatureConfigListContainer className="Feature-Config-View container">
      <ListView
        namespace={configMetadata.namespace}
        selectedKey={configMetadata.key}
        activeHierarchyFiltersConfig={activeHierarchyFiltersConfig}
        activeCityId={activeCityId}
      />
    </FeatureConfigListContainer>
  );
};

const FeatureConfigListContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { FeatureConfig } = state;
  return {
    namespaces: FeatureConfig.namespaces,
    keys: FeatureConfig.keys,
    prevPage: FeatureConfig.prevPage,
    nextPage: FeatureConfig.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureConfig);
